import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirection1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDirection1"><Path d="M12 16.5V20.5M12 16.5H4.5L1.5 12L4.5 7.5H12V16.5ZM12 3.5H19.5L22.5 8L19.5 12.5H12V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDirection1;
